import { ElementViewed } from './types/redventures.usertracking.v3.ElementViewed';

export enum ElementType {
  Link = 'LINK',
  Entry = 'ENTRY',
  Button = 'BUTTON',
}

export type ElementShared = {
  // Required
  webElement: NonNullable<ElementViewed['webElement']>;
};

export enum FormatType {
  ProductCard = 'product-card',
}

export enum FormatSubType {
  Grid = 'grid',
}

export enum CommonVariants {
  AllProductsMixed = 'all-products/mixed',
}

export enum ActionOutcome {
  Click = 'click',
}

export const NYI_STRING = 'tbd';
export const NYI_NUMBER = 0;

export const DEFAULT_USE_IN_VIEW_OPTIONS = {
  threshold: 0.5,
  triggerOnce: true,
};

export const COHESION_BUNDLE_MAPPER = {
  'professional-certificate': 'certificates-prof-cert',
  'professional-program-wl': 'certificates-prof-cert',
  'professional-wl': 'certificates-prof-cert',
  certificate: 'certificates-prof-cert',
  microbachelors: 'certificates-micro-bachelors',
  micromasters: 'certificates-micro-masters',
  xseries: 'certificates-xseries',
  license: 'license',
  bachelors: 'bachelors',
  masters: 'masters',
  doctorate: 'doctorate',
} as const;

export type CohesionBundleType = keyof typeof COHESION_BUNDLE_MAPPER;
